import styled from "styled-components";

import { Colors } from "../../utilities/colors";

const RadioButtonGroup = styled.div`
  position: relative;
  margin-bottom: ${(props) => (props.margin ? props.margin : "0px")};
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
`;
const Label = styled.label`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: ${Colors.labelText};
  position: relative;
  &:before {
    border: 1px solid #d04c8d !important;
  }
`;

const DisabledOverlay = styled.span`
  position: absolute;
  inset: 0;
  cursor: not-allowed;
`;

export default function CheckboxInput({
  name,
  label,
  margin,
  onChange,
  checked,
  disabled
}) {
  const handleClick = () => {
    if (disabled) return;

    onChange?.();
  };
  return (
    <RadioButtonGroup
      onClick={handleClick}
      margin={margin}
      className="checkbox-group"
      $disabled={disabled}
    >
      <input checked={checked} name={name} type="checkbox" disabled={disabled} onChange={() => {}}/>
      <Label>{label}</Label>
      {disabled && <DisabledOverlay />}
    </RadioButtonGroup>
  );
}
